module.exports = __webpack_public_path__ + "media/chicken_meets_worm.5834e36d.mp4";